/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '@/utils/apiClient';
import type { DocumentDetails } from './types';

const extractErrorMessage = (err: any): string => {
  const responseData = err?.response?.data;

  if (!responseData) {
    return err?.message || 'Failed to fetch document details';
  }

  if (typeof responseData === 'string') {
    return responseData;
  }

  if (typeof responseData?.message === 'string') {
    return responseData.message;
  }

  if (typeof responseData?.detail === 'string') {
    return responseData.detail;
  }

  if (Array.isArray(responseData?.non_field_errors)) {
    return responseData.non_field_errors.join(', ');
  }

  if (typeof responseData === 'object') {
    return JSON.stringify(responseData);
  }

  return err?.message || 'Failed to fetch document details';
};

export const fetchDocumentDetails = createAsyncThunk<
  DocumentDetails,
  string,
  { rejectValue: string }
>(
  'docsVerification/fetchDocumentDetails',
  async (documentId, { rejectWithValue }) => {
    try {
      const response = await apiClient(
        `/data/api/v1/documents/everify/?id=${encodeURIComponent(documentId)}`,
        {
          method: 'GET',
        },
      );

      return (response?.data ?? response) as DocumentDetails;
    } catch (err: any) {
      return rejectWithValue(extractErrorMessage(err));
    }
  },
);

export const fetchDocumentByNumber = createAsyncThunk<
  DocumentDetails,
  string,
  { rejectValue: string }
>(
  'docsVerification/fetchDocumentByNumber',
  async (documentNumber, { rejectWithValue }) => {
    try {
      const response = await apiClient(
        `/data/api/v1/documents/everify/?number=${encodeURIComponent(documentNumber)}`,
        {
          method: 'GET',
        },
      );

      return (response?.data ?? response) as DocumentDetails;
    } catch (err: any) {
      return rejectWithValue(extractErrorMessage(err));
    }
  },
);
